import React from "react";
import classNames from "../manage.module.css";
import Typography from "../../../components/ui/typography";

export const PaymentSuccessBox = () => {
  return (
    <div
      style={{ color: "white", fontSize: "1.3rem" }}
      className={"card " + classNames.left_step}
    >
      <Typography
        style={{
          fontWeight: "bold",
          color: "#4caf50",
          fontSize: "22px",
          marginBottom: "10px",
        }}
      >
        ✓ Ödemeniz başarıyla gerçekleşmiştir.
      </Typography>
      <Typography
        style={{
          fontStyle: "italic",
          color: "orange",
          fontSize: "18px",
          marginBottom: "10px",
        }}
      >
        Yarışmaya kaydınız tamamlanmıştır. Ücretsiz Deneme Sınavı, 19 Şubat 2027 Cuma günü saat 13.00'te profil sayfanıza eklenecek ve 26 Şubat 2027 Cuma günü saat 17.00'ye kadar açık kalacaktır. Sınav ekranlarının tanıtımı amacıyla yapılacak olup sonuç açıklanmayacaktır.
      </Typography>
    </div>
  );
};
